import { useState, useEffect } from 'react'

import axios from 'axios'

import { clearDccBridgeFirstUse } from 'Pods/ThreeDStudio/Services/dccBridgeFirstUse'

// ConferenceSignInModal stashes the live event name in localStorage when it strips
// the conference URL param after sign-in. On logout from the booth tablet we pop it
// back into the URL so the next visitor lands on the conference modal again.
function postLogoutTarget() {
  try {
    const raw = localStorage.getItem('conferenceEvent')
    localStorage.removeItem('conferenceEvent')
    const parsed = raw ? JSON.parse(raw) : null
    if (parsed?.event && parsed?.expiresAt > Date.now()) {
      return `/ai?conference=${encodeURIComponent(parsed.event)}`
    }
  } catch (_) { /* malformed or disabled — fall back */ }
  return window.location.pathname + window.location.search
}

function useUserData(isSignedIn) {
  const [userData, setUserData] = useState({})

  useEffect(() => {
    if (isSignedIn) {
      fetchUserData()
    }
  }, [isSignedIn])

  function handleLogout() {
    if (isSignedIn) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      clearDccBridgeFirstUse()

      return axios
        .delete('/users/logout', {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
        .then(() => {
          window.location.assign(postLogoutTarget())
        })
        .catch()
    }

    return null
  }

  function fetchUserData() {
    return axios
      .get('/api/internal/users/me')
      .then(response => {
        setUserData(response.data.data)
      })
      .catch()
  }

  return {
    userData,
    handleLogout,
  }
}

export { useUserData }
